<modal-container #modal [headerIconClass]="'far-file-export'" [headerTitle]="headerTitle" [isLargeModal]="true">
  <ng-container class="modal-button-show">
    <btn
      [label]="'exports'"
      [title]="'exports' | translate"
      [classes]="['btn-third', 'float-right', 'mr-2']"
      [icon]="'far-list-alt'"
      [btnType]="'button'"
      data-cy="exports"
      (click)="showChildModal()"
    ></btn>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="container-fluid pl-0 pr-0">
      <form-row-select
        [label]="'type'"
        [options]="types"
        [(model)]="selectedType"
        (modelChange)="filter()"
      ></form-row-select>
      <app-base-listing
        [storageKey]="storageKey"
        [loadingNextItems]="loading"
        [loadingItems]="reloading"
        [items]="exports"
        [columns]="listingColumns"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [endPage]="endPage"
        [(sortProp)]="filters.sortProp"
        [(sortDir)]="filters.sortDir"
        (reloadList)="filter(1)"
        (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </ng-container>
</modal-container>
